import SectionHeading from "./SectionHeading";
import { platformFeatures } from "@/mocks/shows";

export default function Features() {
  return (
    <section id="features" className="scroll-mt-24 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="平台亮点"
          title="把在线观看与追剧观影拆成四件具体的事"
          description="与其堆砌功能名词，不如直接说明每一件事在页面上是怎么完成的。下面四点覆盖了从打开页面到看完一整季的完整路径。"
        />

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {platformFeatures.map((feature) => (
            <article
              key={feature.id}
              className="reveal group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100/80 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <span className="mt-4 inline-flex w-fit rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
                {feature.tag}
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-7 text-foreground-600">{feature.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}